// Clé de site hCaptcha publique — partagée par tous les formulaires du site.
// Elle doit correspondre au HCAPTCHA_SECRET_KEY configuré dans les secrets
// des Edge Functions Supabase (send-reservation-email et send-contact-email).
// Dashboard : https://dashboard.hcaptcha.com/
export const HCAPTCHA_SITE_KEY = "b294115e-1d08-47cc-84e8-c4c27c722eba";
